import { render, staticRenderFns } from "./NewWithdrawalWithUSDT.vue?vue&type=template&id=79379422&"
import script from "./NewWithdrawalWithUSDT.vue?vue&type=script&lang=js&"
export * from "./NewWithdrawalWithUSDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports